import { useEffect, useState } from "react";
import axios from "axios";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Packages } from "@/components/Packages";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { Chapters } from "@/components/Chapters";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/App";
import { API, PACKAGES, ADDON, IMAGES } from "@/lib/data";

export default function Home() {
  const [selected, setSelected] = useState("estate");
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const packages = settings?.packages?.length
    ? settings.packages.map((p) => ({
        ...p,
        deposit: p.price / 2,
        image: IMAGES[p.id] || IMAGES.estate,
        gallery: p.id === "signature" ? [IMAGES.signature, IMAGES.hero] : [IMAGES[p.id] || IMAGES.estate],
      }))
    : PACKAGES;
  const addon = settings?.addon ? { ...settings.addon, deposit: settings.addon.price / 2 } : ADDON;

  const book = (id) => {
    setSelected(id);
    scrollToId("booking");
  };

  return (
    <main className="bg-[#06130D]">
      <Header />
      <Hero />
      <Marquee />
      <Packages selected={selected} onSelect={setSelected} onBook={book} packages={packages} />
      <Gallery />
      <Reviews />
      <Chapters />
      <Booking selected={selected} onSelect={setSelected} packages={packages} addon={addon} />
      <Footer />
    </main>
  );
}
